// SampleLead.js
import React from "react";
import { useNavigate } from "react-router-dom";

export const sampleLeads = [
  {
    id: 1,
    lead_name: "Rahul Sharma",
    email: "rahul.sharma@example.com",
    contact_number: "+91-9876543210",
    lead_source: "Website",
    terms_conditions: "Agreed to standard terms and conditions.",
    created_at: "2025-09-03 10:15:00",
  },
  {
    id: 2,
    lead_name: "Priya Mehta",
    email: "priya.mehta@example.com",
    contact_number: "+91-9123456780",
    lead_source: "Referral",
    terms_conditions: "Accepted terms for quotation.",
    created_at: "2025-09-02 14:20:00",
  },
  {
    id: 3,
    lead_name: "Amit Verma",
    email: "amit.verma@example.com",
    contact_number: "+91-9988776655",
    lead_source: "LinkedIn",
    terms_conditions: "Wants customized terms before agreement.",
    created_at: "2025-09-01 09:30:00",
  },
  {
    id: 4,
    lead_name: "Sneha Patel",
    email: "sneha.patel@example.com",
    contact_number: "+91-9765432109",
    lead_source: "Email Campaign",
    terms_conditions: "Agreed to receive updates and offers.",
    created_at: "2025-09-01 16:45:00",
  },
  {
    id: 5,
    lead_name: "Arjun Nair",
    email: "arjun.nair@example.com",
    contact_number: "+91-9012345678",
    lead_source: "Cold Call",
    terms_conditions: "Requested detailed terms before proceeding.",
    created_at: "2025-08-31 11:10:00",
  },
];

const SampleLead = () => {
  const navigate = useNavigate();

  return (
    <div style={{ padding: "20px" }}>
      <h2>Sample Leads</h2>
      <table
        style={{
          borderCollapse: "collapse",
          width: "100%",
          border: "1px solid #ddd",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#f2f2f2" }}>
            <th style={styles.th}>ID</th>
            <th style={styles.th}>Lead Name</th>
            <th style={styles.th}>Email</th>
            <th style={styles.th}>Contact Number</th>
            <th style={styles.th}>Lead Source</th>
            <th style={styles.th}>Terms & Conditions</th>
            <th style={styles.th}>Created At</th>
            <th style={styles.th}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {sampleLeads.map((lead) => (
            <tr key={lead.id}>
              <td style={styles.td}>{lead.id}</td>
              <td style={styles.td}>{lead.lead_name}</td>
              <td style={styles.td}>{lead.email}</td>
              <td style={styles.td}>{lead.contact_number}</td>
              <td style={styles.td}>{lead.lead_source}</td>
              <td style={styles.td}>{lead.terms_conditions}</td>
              <td style={styles.td}>{lead.created_at}</td>
              <td style={styles.td}>
                <button
  onClick={() => navigate("/sample-quotation", { state: { leadId: lead.id } })}
  style={{
    backgroundColor: "#4CAF50",
    color: "white",
    padding: "6px 12px",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  }}
>
  View
</button>

              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const styles = {
  th: {
    border: "1px solid #ddd",
    padding: "8px",
    textAlign: "left",
  },
  td: {
    border: "1px solid #ddd",
    padding: "8px",
  },
};

export default SampleLead;
